import React from "react";
import styled from "styled-components";

const CTATextStyled = styled.h3(
  ({ color, theme }) => `
    font-style: italic;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    maxWidth: 600;
    margin: 30px auto;
`
);

export const CTAText = ({ color, children, ...props }) => (
  <CTATextStyled color={color} {...props}>
    {children}
  </CTATextStyled>
);
